import apiClient from "../api/client";

import { search } from "../constants/actionTypes";

export const actions = {
  getProfessionsTree() {
    return (dispatch, getState) => {
      const {
        account: {
          profile: { email },
          preloaders: accountPreloaders
        },
        search: { professions, preloaders }
      } = getState();

      if (!email || accountPreloaders.profile || professions?.length || preloaders.search) {
        return Promise.resolve();
      }

      dispatch(this.setLoading("search", true));
      apiClient({
        method: "get",
        responseType: "json",
        url: "/members/api-v2/professions?command=tree"
      })
        .then(res => {
          dispatch({
            type: search.GET_PROFESSIONS,
            payload: res.data.data
          });
        })
        .catch(() => {
          dispatch({
            type: search.GET_PROFESSIONS_FAIL
          });
        });

      return Promise.resolve();
    };
  },

  getPractices(listingType = null) {
    return dispatch => {
      dispatch(this.setLoading("search", true));

      if (listingType) {
        const params = new URLSearchParams();
        params.set("limit", "all");
        params.set("listing_type", listingType.toLowerCase());
        const url = `/members/api-v2/practice-areas?${params.toString()}`;

        apiClient({
          method: "get",
          responseType: "json",
          url
        })
          .then(res => {
            dispatch({
              type: search.GET_PRACTICES,
              payload: res.data.data
            });
          })
          .catch(() => {
            dispatch({
              type: search.GET_PRACTICES_FAIL
            });
          });
      } else {
        dispatch({
          type: search.GET_PRACTICES_FAIL
        });
      }
    };
  },

  setLoading(section, isLoading) {
    return {
      type: search.SET_LOADING,
      payload: { section, isLoading }
    };
  }
};
